import Aes from "crypto-js/aes";
import CryptoJS from "crypto-js";

const transformDate = (date: any) => {
    const time = new Date(date)
    const year = time.getFullYear()
    const month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
    const day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
    const hour = time.getHours() > 9 ? time.getHours() : '0' + time.getHours()
    const min = time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes()
    const second = time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds()
    return `${year}/${month}/${day} ${hour}:${min}:${second}`
}

const transformDate2 = (date: any, type: any) => {
    const time = new Date(date)
    const year = time.getFullYear()
    const month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
    const day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()

    if (type === 1) {
        return `${year}/${month}/${day} 00:00:00`
    } else if (type === 2) {
        return `${year}/${month}/${day} 23:59:59`
    }
}

const transformDate3 = (date: any) => {
    const time = new Date(date)
    const year = time.getFullYear()
    const month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1)
    const day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
    return `${year}/${month}/${day}`
}

const getRealFactoryIdList = () => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const factories = memberInfo.factories || []
    const factory_id = localStorage.getItem('factory_id')

    // console.log('factories', factories)
    // console.log('factory_id', factory_id)
    let factoryIds: any = []
    const list = factories.filter((p: any) => p.parentId === factory_id)

    if (list && list.length) {
        factoryIds = list.map((p: any) => p.id)
    } else {
        factoryIds = [factory_id]
    }
    return factoryIds
}

const getRealFactoryIdListById = (factory_id: any) => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const factories = memberInfo.factories || []

    let factoryIds: any = []
    const list = factories.filter((p: any) => p.parentId === factory_id)

    if (list && list.length) {
        factoryIds = list.map((p: any) => p.id)
    } else {
        factoryIds = [factory_id]
    }
    return factoryIds
}

const getFactoryName = (id: any) => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const factories = memberInfo.factories
    const info = factories.find((p: any) => p.id === id)
    return info ? info.name : ''
}

const getGroupName = (id: any) => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const groups = memberInfo.groups
    const info = groups.find((p: any) => p.id === id)
    return info ? info.name : ''
}

const getGroupListByFactory = () => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '')
    const groups = memberInfo.groups || []
    const factory_id = localStorage.getItem('factory_id')
    const groupList = groups.filter((p: any) => p.factoryId === factory_id || p.parentId === factory_id)
    return groupList
}

const getGroupListByFacID = (factoryId: any) => {
    const memberInfo: any = JSON.parse(localStorage.getItem('memberInfo') || '[]')
    const groups = memberInfo.groups || []
    const factory_id = factoryId
    const groupList = groups.filter((p: any) => p.factoryId === factory_id || p.parentId === factory_id)
    return groupList
}

const transformBeiJingDate = (date:any) => {
    if(!date) return ''
    let time = new Date(date);

    // Local time timestamp in milliseconds
    const localTimestamp = time.getTime();
    // Time zone difference between local time and Beijing in minutes: Beijing is UTC+8 (-480 minutes), difference = local offset - Beijing offset
    // const offsetDiff = 0 - (localTimezoneOffset() - (-480)); 
    const offsetDiff =  (-480) - time.getTimezoneOffset()
    // Beijing timestamp = local timestamp - time difference (converted to milliseconds)
    const beijingTimestamp = localTimestamp - offsetDiff * 60 * 1000;
    // Format Beijing time
    return new Date(beijingTimestamp).toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
}

const transformLocalDate = (date:any) => {
    if(!date) return ''
    let time = new Date(date);
    let currentDate = new Date()
    const beijingTimestamp = time.getTime();
    const utcTimestamp = beijingTimestamp - 8 * 60 * 60 * 1000;

    // 3. Calculate local time: UTC time + local time zone offset (since the local offset is UTC minus local time, it must be added back)
    const localOffsetMinutes = currentDate.getTimezoneOffset(); // Local offset from UTC in minutes (east is negative)
    const localTimestamp = utcTimestamp - localOffsetMinutes * 60 * 1000;

    // 4. Format local time
    return new Date(localTimestamp).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
}

export {
    transformDate,
    transformDate2,
    transformDate3,
    getRealFactoryIdList,
    getFactoryName,
    getGroupName,
    getGroupListByFactory,
    getRealFactoryIdListById,
    getGroupListByFacID,
    transformBeiJingDate,
    transformLocalDate,
}

const _k = (function () { return '$Y6hE3' + '%ZCGTn0' + 'b9Sl20mm' + "VANksF4WQuq" })();
export const encryptAes = (text: string): string => {
    let key = CryptoJS.enc.Utf8.parse(_k);
    return Aes.encrypt(text, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString();
}

export function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

let conditionList = [
    { label: '健康', value: 0, level: 0 },
    { label: '可用', value: 1, level: 1 },
    { label: '可用', value: 2, level: 1 },
    { label: '警戒', value: 3, level: 2 },
    { label: '警戒', value: 4, level: 2 },
    { label: '警戒', value: 5, level: 2 },
    { label: '故障', value: 6, level: 3 },
    { label: '故障', value: 7, level: 3 }
]

export function convertConditionToLevel(condition: number | null): number {
    if (!condition) return 0;
    let item = conditionList.find(p => p.value === condition);
    if (item) return item.level;
    return 0;
}
